import React, {Component} from 'react'
import Modal from "../Modal";
import UrlModalForm from "../../forms/file/ModalUrlForm";
import PropTypes from "prop-types";

class UrlModal extends Component {
    render() {
        const {id, finishCallback} = this.props;

        return <Modal id={id}>
            {(closeModal) => (
                <UrlModalForm closeModal={closeModal} finishCallback={finishCallback} />
            )}
        </Modal>
    }
}

UrlModal.propTypes = {
    id: PropTypes.string.isRequired,
    finishCallback: PropTypes.func,
};

UrlModal.defaultProps = {
    finishCallback: () => {},
};

export default UrlModal